import React from 'react';

interface ItemPanelProps {
  onClick: VoidFunction;
}

const ItemPanel: React.FC<ItemPanelProps> = ({ onClick, children }) => (
  <div className="panel panel-radio panel-radio-tariff" onClick={onClick}>
    {children}
  </div>
);

export default ItemPanel;
